import React from 'react';
import { Spinner } from 'react-bootstrap';

function SpinnerLoading() {
    return (
        <div className="spinner mb-4">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
            </Spinner>
        </div>
    )
}

export default SpinnerLoading;
